import { API } from '@/api/API'

export type DateAvailabilityStatus = 'available' | 'closed' | 'sold_out' | 'unreleased'

export type TixCalendar = Dict<DateAvailabilityStatus>

export function fetchCalendarForTTs(eventTemplateId, quantities: TicketTypeQuantities): Promise<TixCalendar> {
  const body = {
    ticket_types_required: Object.entries(quantities).map(([typeId, value]) => ({
      ticket_type_id: typeId,
      quantity: value.quantity,
    })),
  }
  return API.post(`events/${eventTemplateId}/calendar`, { body }).then((response) => {
    return response.calendar as TixCalendar
  })
}

export function fetchCalendarForTGs(eventId: string, ticketGroupIds: string[]): Promise<TixCalendar> {
  const query = {
    'ticket_group_id._in': ticketGroupIds.join(','),
  }
  return API.getCached(`events/${eventId}/calendar`, { query }).then((response) => {
    return response.calendar as TixCalendar
  })
}
